module.exports = __webpack_public_path__ + "static/media/app-icon-android-legacy.b21d2cda.png";